module.exports = __webpack_public_path__ + "img/2.21c7a2dd.jpg";